import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import JournalContactDetailModel from 'donor-elf-web/models/all-funds/journal-contact-detail';
import PledgeModel from 'donor-elf-web/models/pledge';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface PledgesDeletRouteModel {
  pledge: PledgeModel;
  journalContactDetails: JournalContactDetailModel[];
}

export default class PledgesDeleteRoute extends Route {
  @service declare store: Store;
  @service declare navbarSettings: NavbarSettingsService;

  beforeModel() {
    this.navbarSettings.title = 'Delete Pledge';
  }

  async model(params: any): Promise<PledgesDeletRouteModel> {
    let pledge = await this.store.findRecord('pledge', params.pledgeId);
    let journalContactDetails = (
      await this.store.query('all-funds/journal-contact-detail', {
        filter: { contact_id: pledge.contactId },
      })
    ).slice();
    return {
      pledge,
      journalContactDetails,
    };
  }
}
